(() => {
  const initGallery = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-sts-slide]')];
    const thumbs = [...root.querySelectorAll('[data-sts-thumb]')];
    const count = root.querySelector('[data-sts-count]');
    let active = 0;
    const show = (next) => {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === active));
      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle('is-active', index === active);
        thumb.setAttribute('aria-pressed', index === active ? 'true' : 'false');
      });
      if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      thumbs[active]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    const stage = root.querySelector('.sts-gallery__stage');
    let startX = 0;
    let startY = 0;
    stage?.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0].clientX;
      startY = event.changedTouches[0].clientY;
    }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy)) show(active + (dx < 0 ? 1 : -1));
    }, { passive: true });
  };
  const initTimeline = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[data-sts-timeline-tab]')];
    const panels = [...root.querySelectorAll('[data-sts-timeline-panel]')];
    tabs.forEach((tab, index) => tab.addEventListener('click', () => {
      tabs.forEach((item, i) => { item.classList.toggle('is-active', i === index); item.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
      panels.forEach((panel, i) => panel.hidden = i !== index);
    }));
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-sts-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-sts-timeline]').forEach(initTimeline);
    scope.querySelectorAll('[data-sts-scroll-buy]').forEach((button) => button.addEventListener('click', () => document.querySelector('[data-sts-buybox], .product__info-container')?.scrollIntoView({ behavior: 'smooth', block: 'center' })));
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
